import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Container, Button, Divider } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#1e293b', mb: 1.5 }}>
      {title}
    </Typography>
    {children}
  </Box>
);

const Para = ({ children }) => (
  <Typography sx={{ fontSize: '0.9rem', color: '#475569', lineHeight: 1.85, mb: 1.5 }}>
    {children}
  </Typography>
);

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', background: '#f8fafc', py: 5, fontFamily: "'Inter', sans-serif" }}>
      <Container maxWidth="md">
        {/* Back button */}
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/login')}
          sx={{ mb: 3, textTransform: 'none', color: '#6366f1', fontWeight: 600, '&:hover': { background: 'rgba(99,102,241,0.06)' } }}
        >
          Back to Login
        </Button>

        {/* Card */}
        <Box
          sx={{
            background: '#fff',
            borderRadius: '16px',
            boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
            p: { xs: 3, md: 5 },
            border: '1px solid #e8ecff',
          }}
        >
          {/* Header */}
          <Box sx={{ mb: 4 }}>
            <Typography sx={{ fontWeight: 900, fontSize: '1.6rem', color: '#0f172a', mb: 0.5 }}>
              Return & Cancellation Policy
            </Typography>
            <Typography sx={{ fontSize: '0.85rem', color: '#94a3b8' }}>
              PayNTric Private Limited · Last Updated: 2026
            </Typography>
          </Box>

          <Divider sx={{ mb: 4, borderColor: '#e8ecff' }} />

          <Para>
            Our primary goal at <strong>PayNTric Private Limited</strong> is to ensure utmost customer satisfaction. Should you find our services unsatisfactory, we offer a refund upon genuine reasons proven after investigation. Please review the specifics of each deal before purchase, as they outline all service or product details.
          </Para>

          <Section title="Refund Policy">
            <Para>
              Regarding refunds, we aim to craft suitable design concepts for our clients. However, if a client isn’t entirely satisfied with our products, we offer a refund option.
            </Para>
            <Para>
              <strong>Refund Process:</strong>
            </Para>
            <Box sx={{ pl: 2, mb: 2 }}>
              <Typography sx={{ fontSize: '0.9rem', color: '#475569', mb: 1 }}>
                • <strong>Credit Card Payments:</strong> Refunds will be credited back to the original card used during the purchase.
              </Typography>
              <Typography sx={{ fontSize: '0.9rem', color: '#475569', mb: 1 }}>
                • <strong>Payment Gateways:</strong> Payments made through payment gateways will be refunded to the same account.
              </Typography>
            </Box>
            <Para>
              <strong>Timelines:</strong>
            </Para>
            <Box sx={{ pl: 2, mb: 2 }}>
              <Typography sx={{ fontSize: '0.9rem', color: '#475569', mb: 1 }}>
                • The <strong>Refund</strong> will be processed in <strong>10 business days</strong>.
              </Typography>
              <Typography sx={{ fontSize: '0.9rem', color: '#475569', mb: 1 }}>
                • Every <strong>verified return</strong> will be processed in <strong>3 business days</strong>.
              </Typography>
            </Box>
          </Section>

          <Divider sx={{ my: 4, borderColor: '#e8ecff' }} />

          {/* Contact Details Box */}
          <Box
            sx={{
              background: '#fafbff',
              border: '1px solid #e8ecff',
              borderRadius: '12px',
              p: 3,
            }}
          >
            <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', color: '#1e293b', mb: 1.5 }}>
              Need Help?
            </Typography>
            {[
              ['Managed By', 'PayNTric Private Limited'],
              ['Address', '07, Golden Nest Appartment, Garhi, Chaukhandi, Noida, Gautam Buddha Nagar, Uttar Pradesh, 201307'],
              ['Email', 'support@jcentrix.com'],
              // ['Helpline', '+91 9407157175'],
            ].map(([label, value]) => (
              <Box key={label} sx={{ display: 'flex', gap: 1, mb: 0.8 }}>
                <Typography sx={{ fontSize: '0.83rem', fontWeight: 600, color: '#64748b', minWidth: 90 }}>{label}:</Typography>
                <Typography sx={{ fontSize: '0.83rem', color: '#475569' }}>
                  {label === 'Email' ? (
                    <a href={`mailto:${value}`} style={{ color: '#6366f1', textDecoration: 'none', fontWeight: 600 }}>{value}</a>
                  ) : label === 'Helpline' ? (
                    <a href={`tel:${value.replace(/\s/g, '')}`} style={{ color: '#6366f1', textDecoration: 'none', fontWeight: 600 }}>{value}</a>
                  ) : value}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default RefundPolicy;
